import { NextRequest } from 'next/server';

import { COOKIE_NAMES } from './constants';

export const getCachedDistinctId = (request: NextRequest): string | null => {
  try {
    const bootstrapCookie = request.cookies.get(
      COOKIE_NAMES.BOOTSTRAP_EXPERIMENTS
    )?.value;

    if (!bootstrapCookie) {
      return null;
    }

    const parsed = JSON.parse(bootstrapCookie) as { distinctID?: string };
    return parsed.distinctID || null;
  } catch {
    return null;
  }
};

export const hasDistinctIdChanged = (
  cachedDistinctId: string | null,
  currentDistinctId: string
): boolean => {
  return Boolean(cachedDistinctId && cachedDistinctId !== currentDistinctId);
};
